<bl-modal-content #content
  [title]="'車検証画像'"
  [footerButtonType]="modalButtonType.Custom"
>
  <div body class="bl-dropzone-preview">
    <img *ngIf="data?.src[imageNum]" src="{{data?.src[imageNum]}}" class="img-thumbnail" [attr.alt]="data?.title">
  </div>
  <div footer>
    <button class="btn btn-default" type="button"
      [disabled]="imageNum === 0"
      (click)="onBack()">前の画像
    </button>
    <button class="btn btn-default" type="button"
      [disabled]="data?.src.length <= imageNum + 1"
      (click)="onNext()">次の画像
    </button>
    <button class="btn btn-success" type="button"
      (click)="content.cancel()">閉じる
    </button>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/page/profile-entries-page/image-modal/image-modal.component.html